import { hasIgnoredCookies } from 'utils/cookies';

export const useHasIgnoredCookies = () => {
  return hasIgnoredCookies();
};
